import React from 'react'
import { useActions, useValues } from 'kea'
import { hot } from 'react-hot-loader'

import I18n from 'lib/i18n'
import SubmitButton from 'lib/tags/submit-button'
import FullScreen from 'lib/components/full-screen'
import Widget from 'lib/tags/widget'

import Logo from '~/scenes/registration/shared/logo'

import logic from '../logic'

const Forgot = () => {
  const { setEmail, submit, setPosition } = useActions(logic)
  const { email, isSubmitting, error, redirecting } = useValues(logic)

  const handleSubmit = event => {
    event.preventDefault()
    submit()
  }

  return (
    <div className='registration-login-scene forgot-password-scene'>
      <FullScreen />
      <Widget>
        <Logo />
        <div className='inside-widget'>
          <h4 className='header-text-align'>{I18n.t('devise.passwords.new.forgot')}</h4>
          <form action='/login' method='POST' onSubmit={handleSubmit}>
            <input
              className='login-input input-text'
              placeholder={I18n.t('activerecord.attributes.user.email')}
              type='email'
              name='email'
              value={email}
              onChange={event => setEmail(event.target.value)}
            />
            {error && <div className='simple-error'>{error}</div>}
            <SubmitButton
              type='submit'
              isSubmitting={isSubmitting || redirecting}
              onClick={submit}
              style={{
                padding: '10px 20px',
                borderRadius: '3px',
                fontWeight: 'bold',
                fontSize: '14px'
              }}
            >
              {I18n.t('devise.passwords.new.submit')}
            </SubmitButton>
            <span className='redirect' onClick={() => setPosition('login')}>
              {I18n.t('devise.sessions.new.login_faster')}
            </span>
          </form>
        </div>
      </Widget>
    </div>
  )
}

export default hot(module)(Forgot)
